export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يبحث"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أنت في وضع التجربة. الأرصدة والمعاملات تدريبية."])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الانتقال إلى الكابينة العملية"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا توجد نتائج"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لوحة التحكم"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["متاجري"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معلومات"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["متجر جديد"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إشعار"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["سجل العمليات"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الدعم"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معلومات الطرف المقابل"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["فحص AML"])}
}